import useProject from './useProject';
export default function useRouterPath() {
    const { projectId } = useProject()
    const getRoutePath = (path) => `/apps/${projectId}${path}`;
    return getRoutePath
}